import { useEffect, useRef } from "react";
import { ADSENSE_CLIENT } from "@/lib/config";

export const AD_SLOTS = { banner: "2343952024" };

export const AdBanner = ({ slot = AD_SLOTS.banner, className = "" }) => {
  const insRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (!ADSENSE_CLIENT || pushed.current || insRef.current?.getAttribute("data-adsbygoogle-status")) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.warn("adsbygoogle push failed", err?.message);
    }
  }, []);

  if (!ADSENSE_CLIENT) return null;
  const mobile = typeof window !== "undefined" && window.innerWidth < 640;
  return (
    <div className={`max-w-7xl mx-auto px-4 sm:px-6 ${className}`} data-testid="ad-banner">
      <p className="text-[10px] uppercase tracking-wider text-slate-400 text-center mb-1">Publicidad</p>
      <div className="flex justify-center overflow-hidden w-full">
        <ins
          ref={insRef}
          className="adsbygoogle"
          style={{ display: "block", width: "100%", maxWidth: 728, minHeight: mobile ? 50 : 90 }}
          data-ad-client={ADSENSE_CLIENT}
          data-ad-slot={slot}
          data-ad-format={mobile ? "auto" : "horizontal"}
          data-full-width-responsive="true"
        />
      </div>
    </div>
  );
};
